import React, { useState, useEffect } from 'react';
import "./ManageLeaves.css";
import { FaSearch, FaEye, FaEdit, FaTimes, FaTrash, FaCheck, FaClock } from "react-icons/fa";
import { API_URL } from "./API";
import AddLeaves from "./AddLeaves";
import UpdateLeaves from "./UpdateLeaves";

const ManageLeaves = ({ onBack, employeeLeaves: propEmployeeLeaves, isLoading: propIsLoading, errorMessage: propErrorMessage }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddLeaves, setShowAddLeaves] = useState(false);
  const [showUpdateLeaves, setShowUpdateLeaves] = useState(false);
  const [selectedLeaveForUpdate, setSelectedLeaveForUpdate] = useState(null);
  const [employeeLeaves, setEmployeeLeaves] = useState(propEmployeeLeaves || []);
  const [isLoading, setIsLoading] = useState(propIsLoading || false);
  const [errorMessage, setErrorMessage] = useState(propErrorMessage || "");
  const [employeeLookup, setEmployeeLookup] = useState({});
  
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [selectedFromDate, setSelectedFromDate] = useState('');
  const [selectedToDate, setSelectedToDate] = useState('');
  const [selectedLeaveType, setSelectedLeaveType] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [leaveToDelete, setLeaveToDelete] = useState(null);


  const sendLeaveApprovalNotification = (leaveData, status, approverName) => {
  const employeeId = leaveData.employee_id;
  
  const notification = {
    id: Date.now(),
    type: status === 'Approved' ? 'leave_approved' : 'leave_rejected',
    message: status === 'Approved' 
      ? `Your ${leaveData.leave_type || 'leave'} request from ${new Date(leaveData.from_date).toLocaleDateString()} has been approved`
      : `Your ${leaveData.leave_type || 'leave'} request from ${new Date(leaveData.from_date).toLocaleDateString()} has been rejected`,
    details: {
      approver: approverName,
      leaveType: leaveData.leave_type,
      fromDate: leaveData.from_date,
      toDate: leaveData.to_date,
      totalDays: leaveData.total_days,
      status: status
    },
    timestamp: new Date().toISOString(),
    read: false
  };

  const existingNotifications = JSON.parse(localStorage.getItem(`notifications_${employeeId}`) || '[]');
  existingNotifications.unshift(notification);
  localStorage.setItem(`notifications_${employeeId}`, JSON.stringify(existingNotifications));
  
  window.dispatchEvent(new Event('notificationUpdate'));
};

  useEffect(() => {
    if (propEmployeeLeaves) {
      setEmployeeLeaves(propEmployeeLeaves);
    }
  }, [propEmployeeLeaves]);

  useEffect(() => {
    setIsLoading(propIsLoading || false);
  }, [propIsLoading]);

  useEffect(() => {
    setErrorMessage(propErrorMessage || "");
  }, [propErrorMessage]);

const getCurrentUserRole = () => {
  const accessLevel = localStorage.getItem('accessLevel');
  const userRole = localStorage.getItem('currentUserRole') || '';
  
  if (userRole.toUpperCase() === 'CEO' || userRole.toUpperCase().includes('CEO')) {
    return 'CEO';
  }
  
  if (accessLevel === 'full' || 
      userRole.toUpperCase() === 'ADMIN' ||
      userRole.toUpperCase().includes('ADMIN') ||
      userRole.toUpperCase() === 'ASSISTANT ADMIN' ||
      userRole.toUpperCase().includes('ASSISTANT')) {
    return 'ADMIN';
  }
  
  return 'EMPLOYEE';
};

  const getCurrentUserId = () => {
    return localStorage.getItem('currentUserId');
  };

  const getCurrentUserName = () => {
    return localStorage.getItem('currentUserName') || 'Current User';
  };

  const getAvailableLeaveTypes = () => {
    const types = employeeLeaves.map(leave => leave.leave_type).filter(Boolean);
    return [...new Set(types)].sort();
  };

const getAvailableEmployees = () => {
  const userRole = getCurrentUserRole();
  const currentUserId = getCurrentUserId();
  const currentUserName = getCurrentUserName();

 
  if (userRole === 'EMPLOYEE') {
    return [{
      id: currentUserId,
      name: currentUserName
    }];
  }

  
  const employees = employeeLeaves
    .filter(leave => leave.employee_id && leave.employee_name)
    .map(leave => ({
      id: leave.employee_id,
      name: leave.employee_name
    }));
  const uniqueEmployees = Array.from(
    new Map(employees.map(emp => [emp.id, emp])).values()
  );
  return uniqueEmployees.sort((a, b) => {
    const nameA = String(a.name || '');
    const nameB = String(b.name || '');
    return nameA.localeCompare(nameB);
  });
};
  const getEmployeeLeaveCount = (employeeId) => {
    return employeeLeaves.filter(leave => String(leave.employee_id) === String(employeeId)).length;
  };

  const getStatusClass = (status) => {
    const statusLower = status?.toLowerCase() || '';
    switch (statusLower) {
      case 'pending':
        return 'ML-status-Pending';
      case 'approved':
      case 'approve':
        return 'ML-status-Approved';
      case 'disapproved':
      case 'rejected':
        return 'ML-status-Disapproved';
      default:
        return '';
    }
  };

  const getStatusIcon = (status) => {
    const statusLower = status?.toLowerCase() || '';
    switch (statusLower) {
      case 'approved':
      case 'approve':
        return <FaCheck className="ML-status-icon" title="Approved" />;
      case 'disapproved':
      case 'rejected':
        return <FaTimes className="ML-status-icon" title="Disapproved" />;
      case 'pending':
      default:
        return <FaClock className="ML-status-icon" title="Pending" />;
    }
  };

  const fetchEmployeeLookup = async () => {
    try {
      const response = await fetch(`${API_URL}/employees/get_employees`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });

      if (response.ok) {
        const result = await response.json();
        const employeesData = result.employees || result.data || result || [];
        
        const employeeLookup = {};
        employeesData.forEach(emp => {
          const id = emp.employee_id || emp.id;
          const name = emp.employee_name || emp.name || `Employee ${id}`;
          employeeLookup[id] = name;
        });
        
        return employeeLookup;
      }
      
      return {};
    } catch (error) {
   
      return {};
    }
  };

  const fetchEmployeeLeaves = async () => {
    setIsLoading(true);
    setErrorMessage("");
    
    try {
      const employeeLookupData = await fetchEmployeeLookup();
      setEmployeeLookup(employeeLookupData);

      const response = await fetch(`${API_URL}/payslips/get_employee_leaves`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Employee leaves API error: ${response.status} - ${errorData.message || response.statusText}`);
      }
      
      const result = await response.json();
      
      let leavesData = [];
      
      if (result.status === "success" && result.data) {
        leavesData = Array.isArray(result.data) ? result.data : [result.data];
      } else if (Array.isArray(result)) {
        leavesData = result;
      } else if (result.leaves && Array.isArray(result.leaves)) {
        leavesData = result.leaves;
      }
      
     const formattedLeaves = leavesData.map(leave => {
  const employeeId = leave.employee_id;
  const employeeName = leave.employee_name || employeeLookupData[employeeId] || `Employee ${employeeId}`;
  
  return {
    ...leave,
    employee_name: employeeName,
    remarks: leave.remarks || ''
  };
});
      setEmployeeLeaves(formattedLeaves);
      
    } catch (error) {
    
      
      if (error.message.includes("Failed to fetch")) {
        setErrorMessage("Network connection failed");
      } else if (error.name === 'TypeError') {
        setErrorMessage("Data processing error");
      } else if (error.message.includes("JSON")) {
        setErrorMessage("Invalid response format");
      } else {
        setErrorMessage(`Error fetching employee leaves: ${error.message}`);
      }
      
      setEmployeeLeaves([]);
    } finally {
      setIsLoading(false);
    }
  };

 useEffect(() => {
    const initializeLeaves = async () => {
      const employeeLookupData = await fetchEmployeeLookup();
      setEmployeeLookup(employeeLookupData);

      if (!propEmployeeLeaves || propEmployeeLeaves.length === 0) {
        fetchEmployeeLeaves();
      } else {
        const formattedLeaves = propEmployeeLeaves.map(leave => {
  const employeeId = leave.employee_id;
  const employeeName = leave.employee_name || employeeLookupData[employeeId] || `Employee ${employeeId}`;
  
  return {
    ...leave,
    employee_name: employeeName,
    remarks: leave.remarks || ''
  };
});
        setEmployeeLeaves(formattedLeaves);
      }
    };

    initializeLeaves();
  }, []);

  const handleAddLeavesClick = () => {
    setShowAddLeaves(true);
  };

 const handleBackToManage = async () => {
  setShowAddLeaves(false);
  setShowUpdateLeaves(false);
  setSelectedLeaveForUpdate(null);
  await fetchEmployeeLeaves();
};

  const handleStatusChange = async (leaveId, newStatus) => {
    try {
      setEmployeeLeaves(prevLeaves =>
        prevLeaves.map(leave =>
          leave.leave_id === leaveId ? { ...leave, status: newStatus } : leave
        )
      );

     
    } catch (error) {
      
      fetchEmployeeLeaves();
    }
  };

  const handleClearFilters = () => {
    setSelectedEmployee('');
    setSelectedFromDate('');
    setSelectedToDate('');
    setSelectedLeaveType('');
    setSelectedStatus('');
    setSearchTerm('');
  };

  const handleViewClick = (leave) => {
    setSelectedLeave(leave);
    setViewModalOpen(true);
  };

const handleUpdateClick = (leave) => {
  const leaveWithRemarks = {
    ...leave,
    remarks: leave.remarks || ''
  };
  setSelectedLeaveForUpdate(leaveWithRemarks);
  setShowUpdateLeaves(true);
};

const handleUpdateSuccess = (updatedData) => {
  setEmployeeLeaves(prevLeaves =>
    prevLeaves.map(leave =>
      leave.leave_id === updatedData.leave_id 
        ? { 
            ...leave, 
            ...updatedData,
            remarks: updatedData.remarks || ''
          } 
        : leave
    )
  );
};

  const handleDeleteClick = (leave) => {
    setLeaveToDelete(leave);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!leaveToDelete) return;

    try {
      const response = await fetch(`${API_URL}/payslips/delete_employee_leave`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify({
          leave_id: parseInt(leaveToDelete.leave_id)
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status === 'success') {
        setEmployeeLeaves(prevLeaves =>
          prevLeaves.filter(leave => leave.leave_id !== leaveToDelete.leave_id)
        );
        
        try {
          const ceoResponse = await fetch(`${API_URL}/employees/get_employees?role=CEO`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            }
          });
          
          if (ceoResponse.ok) {
            const ceoResult = await ceoResponse.json();
            const ceoEmployees = ceoResult.employees || ceoResult.data || [];
            
            for (const ceo of ceoEmployees) {
              await fetch(`${API_URL}/notifications/create`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  employee_id: ceo.employee_id || ceo.id,
                  message: `${leaveToDelete.employee_name} deleted a leave request for ${leaveToDelete.leave_type}`,
                  notification_type: 'leave_deletion',
                  related_id: leaveToDelete.leave_id,
                  created_at: new Date().toISOString()
                })
              });
            }
          }
        } catch (notificationError) {
         
        }
        
        setDeleteModalOpen(false);
        setLeaveToDelete(null);
        alert('Leave deleted successfully');
      } else {
        throw new Error(result.message || 'Failed to delete leave');
      }
    } catch (error) {
    
      alert(`Error deleting leave: ${error.message}`);
    }
  };

  const handleCancelDelete = () => {
    setDeleteModalOpen(false);
    setLeaveToDelete(null);
  };

  if (showAddLeaves) {
    return (
      <AddLeaves 
        onBack={handleBackToManage}
      />
    );
  }

  if (showUpdateLeaves && selectedLeaveForUpdate) {
    return (
      <UpdateLeaves
        leaveData={selectedLeaveForUpdate}
        onBack={handleBackToManage}
        onUpdateSuccess={handleUpdateSuccess}
      />
    );
  }

const filteredLeaves = employeeLeaves.filter(leave => {
  const currentUserId = getCurrentUserId();
  const userRole = getCurrentUserRole();
  
  if (userRole === 'EMPLOYEE') {
    if (!leave.employee_id || !currentUserId) {
      return false;
    }
  
    if (String(leave.employee_id) !== String(currentUserId)) {
      return false;
    }
  }
  
  const employeeNameValue = leave.employee_name || '';
  const reasonValue = leave.reason || '';
  const leaveTypeValue = leave.leave_type || '';
  
  const employeeNameString = String(employeeNameValue).toLowerCase();
  const reasonString = String(reasonValue).toLowerCase();
  const leaveTypeString = String(leaveTypeValue).toLowerCase();
  const searchString = searchTerm.toLowerCase();
  
  const matchesSearch = employeeNameString.includes(searchString) || 
         reasonString.includes(searchString) || 
         leaveTypeString.includes(searchString);
  
  if (selectedEmployee && String(leave.employee_id || '') !== selectedEmployee) {
    return false;
  }
  
  if (selectedFromDate) {
    if (!leave.from_date) return false;
    const leaveFromDate = new Date(leave.from_date);
    const fromDate = new Date(selectedFromDate);
    if (leaveFromDate < fromDate) return false;
  }
  
  if (selectedToDate) {
    if (!leave.to_date) return false;
    const leaveToDate = new Date(leave.to_date);
    const toDate = new Date(selectedToDate);
    if (leaveToDate > toDate) return false;
  }
  
  if (selectedLeaveType && leave.leave_type !== selectedLeaveType) {
    return false;
  }
  
  if (selectedStatus && leave.status && leave.status.toLowerCase() !== selectedStatus.toLowerCase()) {
    return false;
  }
  
  return matchesSearch;
});

  return (
    <div className="ML-00">
      <div className="ML-02">
        <div className="ML-03">
          <div className="ML-05"><FaSearch /></div>
          <input
            type="text"
            className="ML-04"
            placeholder="Search Leave Details"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
     {getCurrentUserRole() !== 'CEO' && (
  <button 
    className="ML-06"
    onClick={handleAddLeavesClick} 
  >
    +Add Leaves
  </button>
)}
      </div>

      <div className="ML-17">
    


<div className="ML-18">
  <label className="ML-19">Employee Name:</label>
  <select 
    value={selectedEmployee} 
    onChange={(e) => setSelectedEmployee(e.target.value)}
    className="ML-20"
  >
    {getCurrentUserRole() !== 'EMPLOYEE' && (
      <option value="">All Employees</option>
    )}
    {getAvailableEmployees().map(emp => (
      <option key={emp.id} value={emp.id}>
        {emp.name}
      </option>
    ))}
  </select>
</div>

        <div className="ML-18">
          <label className="ML-19">From Date:</label>
          <input
            type="date"
            value={selectedFromDate}
            onChange={(e) => setSelectedFromDate(e.target.value)}
            className="ML-21"
          />
        </div>

        <div className="ML-18">
          <label className="ML-19">To Date:</label>
          <input
            type="date"
            value={selectedToDate}
            onChange={(e) => setSelectedToDate(e.target.value)}
            className="ML-21"
            min={selectedFromDate}
          />
        </div>

        <div className="ML-18">
          <label className="ML-19">Leave Type:</label>
          <select 
            value={selectedLeaveType} 
            onChange={(e) => setSelectedLeaveType(e.target.value)}
            className="ML-20"
          >
            <option value="">All Types</option>
            {getAvailableLeaveTypes().map(type => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        <div className="ML-18">
          <label className="ML-19">Status:</label>
          <select 
            value={selectedStatus} 
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="ML-20"
          >
            <option value="">All Status</option>
            <option value="Pending">Pending</option>
            <option value="Approved">Approved</option>
            <option value="DisApproved">Disapproved</option>
          </select>
        </div>
      </div>

      {selectedEmployee && (
        <div className="ML-22">
          <span className="ML-23">Total Leaves by {getAvailableEmployees().find(emp => String(emp.id) === selectedEmployee)?.name}:</span>
          <span className="ML-24">{getEmployeeLeaveCount(selectedEmployee)}</span>
        </div>
      )}

      <div className="ML-07">
        <div className="ML-08">
          <div>Employee Name</div>
          <div>Leave Type</div>
          <div>Reason</div>
          <div>Total Days</div>
          <div>From Date</div>
          <div>To Date</div>
          <div>Status</div>
          <div>Actions</div>
        </div>
        <hr />

        {isLoading && (
          <div className="loading-container">
            <div className="loading-message">Loading employee leaves...</div>
          </div>
        )}

        {errorMessage && (
          <div className="error-container">
            <div className="error-message">{errorMessage}</div>
          </div>
        )}

        {!isLoading && !errorMessage && filteredLeaves.length === 0 && (
          <div className="no-data-container">
            <div className="no-data-message">
              {searchTerm || selectedEmployee || selectedFromDate || selectedToDate || selectedLeaveType || selectedStatus ? 
                'No leaves match your filters' : 
                'No employee leaves found'
              }
            </div>
          </div>
        )}

        {!isLoading && !errorMessage && filteredLeaves.length > 0 && (
          <>
            <div className="data-count-info">
              Showing {filteredLeaves.length} of {employeeLeaves.length} leaves
            </div>
            {filteredLeaves.map((leave, index) => (
              <div key={leave.leave_id || index} className="ML-09">
                <div className="ML-10">{leave.employee_name || 'N/A'}</div>
                <div className="ML-11">{leave.leave_type || 'N/A'}</div>
                <div className="ML-12">{leave.reason || 'N/A'}</div>
                <div className="ML-13">{leave.total_days || 0} days</div>
                <div className="ML-14">{leave.from_date || 'N/A'}</div>
                <div className="ML-15">{leave.to_date || 'N/A'}</div>
                <div className={`ML-16 ${getStatusClass(leave.status)}`}>
                  {getStatusIcon(leave.status)}
                </div>
<div className="ML-25">
  <button 
    className="ML-26"
    onClick={() => handleViewClick(leave)}
    title="View Details"
  >
    <FaEye />
  </button>
  <button 
    className="ML-27"
    onClick={() => handleUpdateClick(leave)}
    title="Update Leave"
  >
    <FaEdit />
  </button>
  {getCurrentUserRole() === 'EMPLOYEE' && (
    <button 
      className="ML-delete-btn"
      onClick={() => handleDeleteClick(leave)}
      title="Delete Leave"
    >
      <FaTrash />
    </button>
  )}
</div>
              </div>
            ))}
          </>
        )}
      </div>

      {viewModalOpen && selectedLeave && (
        <div className="ML-28" onClick={() => setViewModalOpen(false)}>
          <div className="ML-29" onClick={(e) => e.stopPropagation()}>
            <div className="ML-30">
              <h2 className="ML-31">Leave Details</h2>
              <button className="ML-32" onClick={() => setViewModalOpen(false)}>
                <FaTimes />
              </button>
            </div>
            <div className="ML-33">
              <div className="ML-34">
                <div className="ML-35">
                  <span className="ML-36">Employee Name:</span>
                  <span className="ML-37">{selectedLeave.employee_name || 'N/A'}</span>
                </div>
                <div className="ML-35">
                  <span className="ML-36">Employee ID:</span>
                  <span className="ML-37">{selectedLeave.employee_id || 'N/A'}</span>
                </div>
                <div className="ML-35">
                  <span className="ML-36">Leave Type:</span>
                  <span className="ML-37">{selectedLeave.leave_type || 'N/A'}</span>
                </div>
                <div className="ML-35">
                  <span className="ML-36">From Date:</span>
                  <span className="ML-37">{selectedLeave.from_date || 'N/A'}</span>
                </div>
                <div className="ML-35">
                  <span className="ML-36">To Date:</span>
                  <span className="ML-37">{selectedLeave.to_date || 'N/A'}</span>
                </div>
                <div className="ML-35">
                  <span className="ML-36">Total Days:</span>
                  <span className="ML-37">{selectedLeave.total_days || 0} days</span>
                </div>
                <div className="ML-35">
                  <span className="ML-36">Status:</span>
                  <span className={`ML-37 ${getStatusClass(selectedLeave.status)}`}>
                    {getStatusIcon(selectedLeave.status)}
                  </span>
                </div>
               <div className="ML-38">
  <span className="ML-36">Reason:</span>
  <span className="ML-37">{selectedLeave.reason || 'N/A'}</span>
</div>
<div className="ML-38">
  <span className="ML-36">Remarks:</span>
  <span className="ML-37">{selectedLeave.remarks || 'No remarks'}</span>
</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {deleteModalOpen && leaveToDelete && (
        <div className="ML-28" onClick={handleCancelDelete}>
          <div className="ML-29 ML-delete-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ML-30">
              <h2 className="ML-31">Confirm Delete</h2>
              <button className="ML-32" onClick={handleCancelDelete}>
                <FaTimes />
              </button>
            </div>
            <div className="ML-33">
              <p className="ML-delete-message">
                Are you sure you want to delete this leave request?
              </p>
              <div className="ML-delete-info">
                <p><strong>Employee:</strong> {leaveToDelete.employee_name}</p>
                <p><strong>Leave Type:</strong> {leaveToDelete.leave_type}</p>
                <p><strong>Date Range:</strong> {leaveToDelete.from_date} to {leaveToDelete.to_date}</p>
              </div>
              <div className="ML-delete-actions">
                <button className="ML-delete-cancel-btn" onClick={handleCancelDelete}>
                  Cancel
                </button>
                <button className="ML-delete-confirm-btn" onClick={handleConfirmDelete}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageLeaves;